import { render } from "./Exif.vue?vue&type=template&id=08c439a0"
const script = {}

import "./Exif.vue?vue&type=style&index=0&id=08c439a0&lang=css"

import exportComponent from "/Users/dmitrii.verov/website/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__